// custom-reviews.js

document.addEventListener('DOMContentLoaded', function () {
    var masonryGrid = document.querySelector('.jdgm-all-reviews__body');
    if (masonryGrid) {
        new Masonry(masonryGrid, {
            itemSelector: '.jdgm-rev',
            columnWidth: '.jdgm-rev', // Tự động cột dựa trên kích thước của item
            gutter: 20, // Khoảng cách giữa các cột
            percentPosition: true, // Đảm bảo tính toán layout chính xác
        });
    }

    const reviews = document.querySelectorAll('.jdgm-rev'); // Chọn tất cả các review
    const loadMoreBtn = document.querySelector('.jdgm-all-reviews-page__load-more');
    let currentVisible = 6; // Ban đầu hiển thị 6 review

    reviews.forEach((review, index) => {
        if (index >= currentVisible) {
            review.style.display = 'none';
        }
    });

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();

            const totalReviews = reviews.length;
            const newVisible = currentVisible + 6; 

            reviews.forEach((review, index) => {
                if (index < newVisible) {
                    review.style.display = 'block';
                }
            });

            currentVisible = newVisible;

            if (currentVisible >= totalReviews) {
                loadMoreBtn.style.display = 'none';
            }

            if (window.Masonry) {
                const masonryInstance = Masonry.data(masonryGrid);
                if (masonryInstance) masonryInstance.layout();
            }
        });
    }
});
